import { render, staticRenderFns } from "./DashboardScreen.vue?vue&type=template&id=0ec989ba&scoped=true"
import script from "./DashboardScreen.vue?vue&type=script&lang=js"
export * from "./DashboardScreen.vue?vue&type=script&lang=js"
import style0 from "./DashboardScreen.vue?vue&type=style&index=0&id=0ec989ba&prod&scoped=true&lang=css"
import style1 from "./DashboardScreen.vue?vue&type=style&index=1&id=0ec989ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec989ba",
  null
  
)

export default component.exports